import { z } from 'zod'

export enum KnowledgeEntryType {
  TEXT = 'text',
  FILE = 'file',
  LINK = 'link',
}

export enum KnowledgeEntryState {
  PROCESSED = 'processed',
  IN_PROCESSING = 'in processing',
}

const textEntrySchema = z.object({
  id: z.string().uuid(),
  type: z.literal(KnowledgeEntryType.TEXT),
  state: z.nativeEnum(KnowledgeEntryState).optional(),
  data: z.object({
    text: z.string(),
  }),
})

const linkEntrySchema = z.object({
  id: z.string().uuid(),
  type: z.literal(KnowledgeEntryType.LINK),
  state: z.nativeEnum(KnowledgeEntryState).optional(),
  data: z.object({
    url: z.string().url(),
  }),
})

const fileEntrySchema = z.object({
  id: z.string().uuid(),
  type: z.literal(KnowledgeEntryType.FILE),
  state: z.nativeEnum(KnowledgeEntryState).optional(),
  data: z.object({
    file: z.string(),
  }),
})

export const knowledgeEntrySchema = z.discriminatedUnion('type', [
  textEntrySchema,
  linkEntrySchema,
  fileEntrySchema,
])

export const AiBusinessKnowledgeSchemas = {
  retrieve: {
    response: z.object({
      data: z.array(knowledgeEntrySchema),
    }),
    query: z.undefined(),
    path: z.undefined(),
  },
  create: {
    request: z.object({
      data: knowledgeEntrySchema,
    }),
    response: z.object({
      data: z.object({
        state: z.nativeEnum(KnowledgeEntryState),
      }),
    }),
    query: z.undefined(),
    path: z.undefined(),
  },
  updateData: {
    request: z.object({
      data: knowledgeEntrySchema,
    }),
    response: z.object({
      data: z.object({
        state: z.nativeEnum(KnowledgeEntryState),
      }),
    }),
    query: z.undefined(),
    path: z.undefined(),
  },
  delete: {
    request: z.object({
      id: z.string().uuid(),
    }),
    response: z.undefined(),
    query: z.undefined(),
    path: z.undefined(),
  },
}

export type KnowledgeEntry = z.infer<typeof knowledgeEntrySchema>
export type TextEntry = z.infer<typeof textEntrySchema>
